export default {
  FETCH_DATA: 'single_cont_fetch_data',
  UPDATE_QUERY: 'single_cont_update_query',
  LOAD_MORE_DATA: 'single_cont_load_more_data',
  UPDATE_LOADING: 'single_cont_update_loading',
  UPDATE_SELECTED: 'single_cont_update_selected',
  UPDATE_ACTIVE_DETAIL: 'single_cont_active_detail',
};
